import React from 'react';
import { CoreForumViewNode } from '../core/CoreForumViewNode';

/**
 * TagForumViewNode - Tagged Forum 专用的节点查看组件包装器
 * @param {Function} props.buildGroupContext - 从页面传递的 context 构建函数
 * @param {string} props.mode - 模式标识
 */
export const TagForumViewNode = ({ 
  open, 
  onClose, 
  nodeContent, 
  ws, 
  groupId, 
  graphNodes,
  graphEdges, // ✅ 新增參數
  allTagConfigs = {},
  onEditorOpen,
  onEditorClose,
  buildGroupContext,
  mode = 'tagged-forum',
  onRefresh,
  onNodeUpdated,
  onNodeDeleted
}) => {
  return (
    <CoreForumViewNode
      open={open}
      onClose={onClose}
      nodeContent={nodeContent}
      ws={ws}
      groupId={groupId}
      graphNodes={graphNodes}
      graphEdges={graphEdges} // ✅ 傳遞參數
      allTagConfigs={allTagConfigs}
      onEditorOpen={onEditorOpen}
      onEditorClose={onEditorClose}
      buildGroupContext={buildGroupContext}
      mode={mode}
      onRefresh={onRefresh}
      onNodeUpdated={onNodeUpdated}
      onNodeDeleted={onNodeDeleted}
    />
  );
};
